module.exports = __webpack_public_path__ + "img/emoji_37.fd699a86.png";